<div class="address-thanks">
  <div class="address-popup">
    <ion-row>
      <ion-col class="ion-text-right" >
        <ion-icon name="close" class="--close" (click)="close()"></ion-icon>
      </ion-col>
    </ion-row>
  <ion-card>
      <ion-card-header>
        <ion-row>
          <ion-col class="ion-text-center">
            <h2 class="head">
              Thank You<br>
              For Your Order
            </h2>
          </ion-col>
        </ion-row>
      </ion-card-header>
      <ion-card-content>
        <ion-row>
          <ion-col class="ion-text-center">
              <span class="small-order-text">
                Order No. {{orderId}}<br>
                  Order Date: {{currentDate}}
              </span>
          </ion-col>
        </ion-row>
       
        <ion-row style="margin-top: 1rem;">
          <ion-col class="ion-text-center">
            <div class="right-tick">
             <img src="./assets/img/right-tick.svg" style="width: auto;height: 80%;border-radius:100%;">
            </div>
          </ion-col>
        </ion-row>
       
        <ion-row>
          <ion-col class="ion-text-center">
            <div class="estimate-delivery">
              Estimated Delivery <br>
              {{deliveryDate}}
            </div>
          </ion-col>
        </ion-row>
        <ion-row style="margin-top: 1rem;">
          <ion-col class="ion-text-center">
            <div class="info">
              We've emailed you a confirmation and we'll notify you when order has shipped.
            </div>
          </ion-col>
        </ion-row>
        <br>
        <ion-row>
          <ion-col class="ion-text-center">
            <div>
              <ion-button (click)="viewOrder()"  style="width: 100%;
              display: inline-block;--background: #DEB221;" class="btn button-full" shape="round">View Order</ion-button>
            </div>
          </ion-col>
        </ion-row><br>
        <ion-row>
          <ion-col class="ion-text-center">
            <div>
              <ion-button  (click)="help()"  style="width: 100%;
              display: inline-block;--background:transparent; border: 1px solid #565656;border-radius: 25px;" class="btn button-full" shape="round">
              <img src="./assets/img/whatsapp.png" style="width: auto;height: 100%;">
              <span style="color:#8C8E93;font-style: normal;">Help</span>  
            </ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-card-content>
  </ion-card>
</div>
</div>
